(function() {
    'use strict';
    angular
        .module('gatewayApp')
        .factory('ForexConfigurations', ForexConfigurations);

        ForexConfigurations.$inject = ['$resource'];

    function ForexConfigurations ($resource) {
		var resourceUrl =  '/api';
		return $resource(resourceUrl, {}, {
		    'get' : {
			    method : 'GET',
			    params: {id : '@id'},
			    url:'api/manage-forex-configurations/:id',
			    transformResponse : function(data) {
                 if (data) {
                    return angular.fromJson(data);
                    }
                    return data;
			    }
		    },
            'getForexConfigurations': {
                method: 'GET',
                isArray: true,
                params: {bankId:'@bankId'},
                url: 'api/forex-configurations/:bankId',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getAllForexConfigurations': {
                method: 'GET',
                isArray: true,
                url: 'api/forex-configurations/',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {
            	method:'POST',
            	params: {corpId:'@corpId'},
                url: 'api/manage-forex-configurations/:corpId',
                transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
                   }
            },
            'approve': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/approve'
            },
            'reject': {
                method: 'GET',
                params: {taskId:'@taskId'},
                url: 'api/tasks/:taskId/reject'
            },
            'discard': {
              	 method: 'GET',
                   params: {taskId:'@taskId'},
                   url: 'api/tasks/:taskId/discard'
             },
             'resubmitForCreate': {
                 method: 'PUT',
                 params: {taskId:'@taskId'},
                 url: 'api/tasks/:taskId/resubmitForCreate/forex-configurations-details',
                 transformRequest: function (data) {
                 	var copy = angular.copy(data);
                 	return angular.toJson(copy);
                 }
             },
             'exportForexConfigurationsExcel':{
				method: 'POST',
                params: {bankId : '@bankId'},
				url: 'api/forex-configurations/export/excel',
				responseType: 'arraybuffer',
				transformRequest: function (data) {
	                   	var copy = angular.copy(data);
	                   	
	                       return angular.toJson(copy);
	            },
				transformResponse: function(data, headers) {
					return {
						data: data,
						headers: headers
					};   
				}      
			},
			'exportForexConfigurationsCsv':{
				method: 'POST',
                params: {bankId : '@bankId'},
				url: 'api/forex-configurations/export/csv',
				responseType: 'arraybuffer',
				transformRequest: function (data) {
                   	var copy = angular.copy(data);
                   	
                       return angular.toJson(copy);
            },
			transformResponse: function(data, headers) {
				return {
					data: data,
					headers: headers
				};   
			}         
			},
        });
    }
})();